<template>
    <md-report-layout :header-buttons="headerButtons" :loading="loading" :loading-text="loadingText">
        <template v-slot:header-left>
            <dateselectionheader style="position:static;" :label="`${reportYear}`" :disableCalendar="true"
                                 :disableToday="true"
                                 @PrevDate="changeSelection('down')" @NextDate="changeSelection('up')" />
        </template>
        <template v-slot:employee-list>
            <div style="margin-top: 1rem; display: flex; flex-direction: row; justify-content: center;">
                <h5>{{ $t('report.main.businessUnitSelection') }}</h5>
                <div style="float: right; margin-left: 15px;">
                    <i v-if="!toggleSpots" class="fas fa-chevron-circle-down closed"
                       v-on:click="toggleSpots=!toggleSpots"></i>
                    <i v-else class="fas fa-chevron-circle-up opened" v-on:click="toggleSpots=!toggleSpots"></i>
                </div>
            </div>
            <div class="body mt-3 mb-4 text-right" style="max-height: 300px; overflow: auto;" v-if="toggleSpots">
                <div v-for="spot in spotMap" class="mb-2" :key="spot.id">
                    <div style="float:left; line-height:30px;"> {{ spot.name }} &nbsp;</div>
                    <buttonc type="rectangle" :label="$t('global.ui.selectAll')"
                             v-on:click="selectEmployeeWithSpot('select',spot.id)"
                             style="width: auto; height: auto; padding: 5px" />
                    <buttonc type="rectangle" :label="$t('global.ui.deselectAll')"
                             v-on:click="selectEmployeeWithSpot('deselect',spot.id)"
                             style="width: auto; height: auto; padding: 5px" />
                </div>
            </div>
            <EmployeeList :class="anonMode ? 'anonblur' : ''" :loading="loadingEmployees" :employees="visibleEmployees"
                          @employeeSelected="onEmployeeSelected"
                          :style="{height: toggleSpots ? 'calc(100vh - 650px)' : 'calc(100vh - 300px)'}" />
            <div class="header"
                 style="font-size: 13px; padding-left: 5px; font-weight:bold; margin-bottom: 10px; text-align: left">
                {{ $t('report.main.xOfYEmployeesSelected', [countSelectedEmployees, countEmployees]) }}
            </div>
            <EmployeeButtons :selectAllEmployees="selectAllEmployees" :deselectAllEmployees="deselectAllEmployees"
                             :toggleShowOnlyActiveEmployees="toggleShowOnlyActiveEmployees"
                             :showOnlyActiveEmployees="showOnlyActiveEmployees" />
        </template>
        <template v-slot:report-settings>
            <ReportConfig :options="reportConfigData" @configChanged="onReportConfigChange" />
        </template>

        <template v-slot:report-list>
            <div style="text-align:left; font-weight:bold; font-size: 20px;">
                {{ $t('report.main.reportList') }}
            </div>
            <div  class="reports-list">
                <datatablesimple :state="reportState" />
            </div>
            <div v-if="reports.length == 0">
                {{ $t('report.main.noReportsCreated') }}
            </div>
        </template>
        <template v-slot:button-bar v-if="creatingReport || selectedEmployees.length === 0">
      <span v-if="creatingReport">
        <i class="fas fa-circle-notch fa-spin"></i>
        {{ $t('report.main.reportCreating') }}
      </span>
            <span v-else>
        {{ $t('pref.main.pleaseSelectEmployee') }}
      </span>
        </template>
    </md-report-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import MdReportLayout from '@/components/reportcontext/ReportLayout';
import MdDateSelect from '@/components/uicomponents/md-date-select';
import { reportMixin } from '@/components/reportcontext/report-mixin';
import EmployeeList from '@/shared/components/EmployeeList.vue';
import EmployeeButtons from '@/shared/components/EmployeeButtons.vue';
import ReportConfig from '@/shared/components/ReportConfig.vue';

export default {
  name: 'reportweekendsoffoverview',
  components: {
      ReportConfig,
      EmployeeButtons,
      EmployeeList,
    MdDateSelect,
    MdReportLayout,
  },
  mixins: [ reportMixin ],
  data() {
    return {
      reportYear: 2020,
      loadingText: this.$t('report.main.loadX', [this.$t('store.templates.freeWeekends')]),
      showOnlyActiveEmployees: true,

      toggleSpots: false,
    }
  },
  created() {
    this.reportYear = this.$helpers.getCurrentMonthMomentTZ().year()-1;
    
  },
  mounted() {
    if (this.$store.state.jwt !== undefined && this.$store.state.storeId !== undefined) {
      this.refresh();
    }
  },
  computed: {
    ...mapGetters([ 'spotMap' ]),

    headerButtons() {
      let helperLinks = [];
      let buttons = [
        {
          classes: 'add-employeetype',
          type: 'block gray',
          disabled: false,
          icon: 'fa-th-list',
          click: ($event) => {
          },
          show: true,
          tooltip: this.$t('store.templates.freeWeekends'),
          title: this.$t('store.templates.freeWeekends'),
          helperText: this.$t('report.main.freeWeekendsHelp'),
          //externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/1134428161"
        },
        {
          type: 'block green',
          disabled: this.creatingReport || this.selectedEmployees.length === 0,
          icon: this.creatingReport ? 'fa-redo' : 'fa-file-check',
          click: ($event) => {
            this.generateReport();
          },
          show: true,
          tooltip: this.$t('global.ui.createX', [this.$t('roster.view.report')]),
        },
      ];
      let state = {
        buttons: buttons,
        helperLinks: helperLinks,
        showListIconAlways: true,
      };

      state.helperLinks = [
        {
          title:  this.$t('store.structure.getSupport'),
          helperText: this.$t('store.structure.getSupportHelp'),
          externalUrl: 'https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/15',
          externalLabel:  this.$t('store.structure.getSupportLabel'),
          cancelLabel: this.$t('global.ui.close'),
        },
      ];
      return state;
    },
      reportState() {
          if (this.reports === undefined || this.reports.length < 1) {
              return null;
          }

          let data = Object.values(this.reports);

          let columns = {
              name: this.$t('report.main.documentName'),
              format: this.$t('report.main.fileFormat'),
              creationDate: this.$t('global.menubar.sortOptionCreationDate'),
              comment: this.$t('global.general.comment'),
              actions: ' ',
          };

          let state = this.$helpers.GetDataTableStateFromKeyLabelObject(columns, data);

          this.$helpers.buildHeaderMapLabel(state.headerMap, 'name');
          this.$helpers.buildHeaderMapLabel(state.headerMap, 'format');
          this.$helpers.buildHeaderMapLabel(state.headerMap, 'creationDate');
          this.$helpers.buildHeaderMapLabel(state.headerMap, 'comment');
          this.$helpers.buildHeaderMapLabel(state.headerMap, 'actions');
          state.headerMap.actions.componentStateBuilders = [
              (data) => {
                  return {
                      componentType: 'buttonc',
                      tooltip: () => {
                          return this.$t('global.ui.open');
                      },
                      type: 'button square rounded no-border',
                      icon: 'fas fa-envelope-open',
                      customEvents: {
                          click: () => {
                              this.openReportUrl(data.url);
                          },
                      },
                  };
              },
              (data) => {
                  return {
                      componentType: 'buttonc',
                      tooltip: () => {
                          return this.$t('global.general.download');
                      },
                      type: 'button square rounded no-border green',
                      icon: 'fas fa-download',
                      customEvents: {
                          click: () => {
                              this.downloadReport(data);
                          },
                      },
                  };
              },
              (data) => {
                  return {
                      componentType: 'buttonc',
                      tooltip: () => {
                          return this.$t('global.ui.delete');
                      },
                      type: 'button square rounded no-border red',
                      icon: 'fas fa-trash',
                      customEvents: {
                          click: () => {
                              this.openDeleteReportPopup(data);
                          },
                      },
                  };
              },
              // open report openReport
          ];

          let entries = Object.entries(state.headerMap);

          entries[0][1].key = 'name';
          entries[0][1].width = '30%';
          entries[1][1].key = 'format';
          entries[1][1].width = '10%';
          entries[2][1].key = 'creationDate';
          entries[2][1].width = '20%';
          entries[3][1].key = 'comment';
          entries[3][1].width = '25%';
          entries[4][1].key = 'actions';
          entries[4][1].width = '15%';

          state.headerStyles = { fontSize: '10px', position: 'sticky', top: 0, zIndex: 10 };
          state.heightSubRow = 'fit-content';
          state.rowStylesCollapsed = this.strippedRowStyle();
          state.alwaysUnfold = false;

          return state;
      },
  },
  watch: {
    storeId(newVal, oldVal) {
      this.refresh(true);
    },
    rangeStart() {
      this.updateReportConfig('reportname', this.getReportName());
    },
  },
  // methods that implement data logic.
  methods: {
    getReportName() {
      return this.$t('store.templates.freeWeekends') + ', ' + this.reportYear;
    },
    async refresh(force = false) {
      this.loading = true;
      this.updateReportConfig('reportname', this.getReportName());
      let from = this.$helpers.getMomentFromValuesTZ(this.reportYear, 0, 1);
      let to = from.clone().add(1, 'year');
      try {
        await Promise.all([
          this.$helpers.GetExportSettingsMap(force),
          this.loadReportsWrapper(),
          this.loadEmployees(true, from, to),
          this.$helpers.GetSpotMap(true),
        ]);
      } catch (error) {
        console.error(error);
      } finally {
        this.generateReportConfigOpts();
        
        this.reportConfig = this.loadReportConfig();
        this.updateReportConfig('reportname', this.getReportName());
        this.loading = false;
      }
    },

    selectEmployeeWithSpot(method, spotId) {
      this.employeeList = this.employeeList.map((employee) => ({
        ...employee,
        selected: employee.spotId === spotId ? method === 'select' : employee.selected,
      }));
    },

    generateReportConfigOpts() {
      let disabled = !this.CheckEnableConfigEdit
      let specialDisabled = !this.CheckEnableConfigSpecialEdit
      const nameSection = this.createReportConfigSection(this.$t('report.main.documentName'), true);
      this.addTextConfigOption(nameSection, 'reportname', this.$t('report.main.enterDocumentName'), this.getReportName(), true);

      const commentSection = this.createReportConfigSection(this.$t('global.general.comment'));
      this.addTextConfigOption(commentSection, 'reportcomment', this.$t('report.main.enterComment'));

      const formatSection = this.createReportConfigSection(this.$t('report.main.fileFormat'), false, disabled);
      this.addSelectConfigOption(formatSection, 'fileformat', [
        this.addSelectableValue('PDF', 'pdf', true),
        // this.addSelectableValue('CSV', 'csv'),
      ]);

      const empSortMethodSection = this.createReportConfigSection(this.$t('report.main.employeeSort'), false, disabled);
      this.addSelectConfigOption(empSortMethodSection, 'sortMethod', [
        this.addSelectableValue(this.$t('pages.employeeData.lastname'), 'lastName', true),
        // { value: 'firstName', title: 'Vorname' },
      ]);

      const headerFormatSection = this.createReportConfigSection(this.$t('report.main.header'), false, specialDisabled);
      this.addSelectConfigOption(headerFormatSection, 'settingDateFormat', [
        this.addSelectableValue('DD.MM.YYYY', 'DD.MM.YYYY', true),
        this.addSelectableValue('YYYY-MM-DD', 'YYYY-MM-DD'),
      ]);
      this.addSelectConfigOption(headerFormatSection, 'headerShowQr', [
        this.addSelectableValue(this.$t('global.ui.showX', [this.$t('report.main.qrCode')]), true, true),
        this.addSelectableValue(this.$t('global.ui.hideX', [this.$t('report.main.qrCode')]), false),
      ]);
    },

    changeSelection(method) {
      if (method === 'down') {
        this.reportYear--;
      } else {
        this.reportYear++;
      }

      this.updateReportConfig('reportname', this.getReportName());
      let from = this.$helpers.getMomentFromValuesTZ(this.reportYear, 0, 1);
      let to = from.clone().add(1, 'year');
      this.loadEmployees(true, from, to);
    },

    async generateReport() {
      this.creatingreport = true;

      let employeeIds = this.selectedEmployeeIds;

      const dateFormats = {
        'DD.MM.YYYY': 'dmY',
        'YYYY-MM-DD': 'Ymd',
      };
      const dateFormat = dateFormats[this.reportConfig.settingDateFormat] || 'dmY';

      const docTypes = {
        'kv': 'WEEKENDSOFFOVERVIEW',
        'plan': 'WEEKENDSOFFOVERVIEW',
      };
      const documentType = docTypes[this.reportConfig.settingCalculationMethod] || docTypes.kv;
      // as createReport in reportMixin automatically calls toLowerCase for payload.config.documentType,
      //  there is no need to lowercase it here
      // let calculationMethod = 'staffexpenses';

      const name = this.reportConfig.reportname;
      const comment = this.reportConfig.reportcomment;
      const config = {
        'year': this.reportYear,
        'employeeIds': employeeIds,
        'headerDateFormat': dateFormat,
        'showFirstWorkday': this.reportConfig.showFirstWorkday,
        'headerShowQr': this.reportConfig.headerShowQr,
        'documentComment': comment,
      };
      await this.createReport(documentType, name, comment, config);
      await this.loadReportsWrapper();
    },

    async loadReportsWrapper() {
      const reports = await this.loadReports();
      const allowedTypes = {
        'WEEKENDSOFFOVERVIEW': true,
      };
      this.reports = reports.filter(({ documentType }) => allowedTypes[documentType.toUpperCase()]);
    },
  },
}
</script>

<style scoped>
</style>
